var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"card no-content"},[_c('div',{staticClass:"card-body"},[_vm._t("default",[_vm._v("No content available.")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }